import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import _isEmpty from 'lodash/isEmpty';
import Banner from 'yoda-core-components/lib/components/Banner/Banner';
import Button from 'yoda-core-components/lib/components/Button/Button';
import ModalBox from 'yoda-core-components/lib/components/ModalBox/ModalBox';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import RichText from '../../../RichText/RichText';
import { getMediaTypeForDeviceType } from '../../../../utils';
import {
    getInteractiveVizNavFromSession,
    setInteractiveVizNavInSession,
} from '../../../../helpers/Utils/interactiveVizNav';

import * as styles from './LandingModal.css';

const cx = classNames.bind(styles);

export class FitFinderLandingModal extends PureComponent {
    constructor() {
        super();
        this.state = {
            isFitFinderLandingModalOpened: true,
            isMounted: false,
        };
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        /*
         * This is to make sure the component has mounted since ModalBox uses DOM
         * https://reactjs.org/docs/faq-ajax.html#example-using-ajax-results-to-set-local-state
         */
        /* eslint-disable react/no-did-mount-set-state */
        this.setState({ isMounted: true });
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setLandingModalRef = (node) => {
        this.landingModalRef = node;
    };

    getBanner = (altText, relativePath) => (
        <Banner
            automationId="Fit Finder modal image"
            bannerImageUrl={relativePath}
            bannerImageClass={`${dt(['mx-auto'])} ${cx('bannerPromoImage')}`}
            altText={altText}
            ariaLabel={altText}
        />
    );

    handleClickOutside = (event) => {
        if (this.landingModalRef && !this.landingModalRef.contains(event.target)) {
            this.toggleModal();
        }
    };

    toggleModal = () => {
        const { programId, cacheMins } = this.props;
        setInteractiveVizNavInSession(programId, 'isModalOpenedForSession', true, cacheMins);
        this.setState({
            isFitFinderLandingModalOpened: false,
        });
    };

    renderBanner = () => {
        const { deviceType, popup } = this.props;
        const { altText = '', url = '' } = getMediaTypeForDeviceType(deviceType, popup);

        return this.getBanner(altText, url);
    };

    render() {
        const { popup, programId, customClass } = this.props;
        if (_isEmpty(popup)) {
            return null;
        }
        const { headline = '', subHeadline = '', linkText = '' } = popup;
        const { isModalOpenedForSession } = getInteractiveVizNavFromSession(programId);
        const showModal =
            !isModalOpenedForSession &&
            this.state.isFitFinderLandingModalOpened &&
            this.state.isMounted;

        return (
            <ModalBox
                showModal={showModal}
                renderModalToBody
                onClose={() => this.toggleModal()}
                defaultHeader
                modalOverlayTheme={cx('modalOverlayTheme')}
                modalBlockTheme={cx('modalbox-height')}
                automationId="at-cpn-serial-modal"
                modalTheme={cx('modelFitFinderMainTheme')}
                modalContentTheme={cx('modalContentTheme')}
                wrapperAutomationId="landingmodal"
                overlayAutomationId="landingOverlay"
            >
                <div
                    ref={this.setLandingModalRef}
                    className={cx('fitFinderModelContainer', customClass)}
                >
                    <div className={cx('finFinderContentBlock')}>
                        <h3
                            data-automation-id="landingmodal-title"
                            className={cx('fitFinderTitle')}
                        >
                            <RichText text={headline} />
                        </h3>
                        <h4
                            data-automation-id="landingmodal-description"
                            className={cx('fitFinderDesc')}
                        >
                            <RichText text={subHeadline} />
                        </h4>
                    </div>
                    <div
                        data-automation-id="landingmodal-image"
                        className={cx('fitFinderImageBlock')}
                    >
                        {this.renderBanner()}
                    </div>
                    <div className={cx('btnBlock')}>
                        <Button
                            type="button"
                            onClick={() => this.toggleModal()}
                            automationId="landingmodal-btn"
                            buttonType="Primary"
                            className={`${dt(['mx-auto'])} ${cx('fitFinderBtn')}`}
                            size="Md"
                        >
                            <RichText text={linkText} />
                        </Button>
                    </div>
                </div>
            </ModalBox>
        );
    }
}

FitFinderLandingModal.propTypes = {
    deviceType: PropTypes.object.isRequired,
    popup: PropTypes.object,
    programId: PropTypes.string,
    cacheMins: PropTypes.number.isRequired,
    customClass: PropTypes.string,
};

FitFinderLandingModal.defaultProps = {
    popup: {},
    programId: '',
    customClass: '',
};

export default FitFinderLandingModal;
